import { CircularProgress, IconButton } from "@material-ui/core"
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle"
import PropTypes from "prop-types"
import { useContext, useState } from "react"
import { useMutation, useQueryClient } from "react-query"
import { removeLabInstance } from "~/actions/labs"
import AppContext from "~/contexts/App"
import LabContext from "~/contexts/Lab"
import LabsContext from "~/contexts/Labs"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"

import Box from "~/components/Common/Box"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"

import useStyles from "./styles"

const InstanceCard = ({ instance, disabled = false }) => {
  const queryClient = useQueryClient()
  const classes = useStyles()
  const { instanceTypes } = useContext(LabsContext)
  const { lab } = useContext(LabContext)
  const { openDialog, openSnackBar } = useContext(AppContext)
  const [removing, setRemoving] = useState(false)
  const openErrorSnackbar = useOpenErrorSnackbar()
  const openEditDialog = () => {
    openDialog("editInstanceDialog", { instanceTypes, lab, instance })
  }

  const removeInstanceMutation = useMutation((data) =>
    removeLabInstance(data[0].id, data[0].lab_id),
  )

  const handleRemoveInstance = () => {
    setRemoving(true)
    // await removeInstance(instance)
    removeInstanceMutation.mutate([instance], {
      onSuccess: (res) => {
        queryClient.setQueryData(["lab", lab.id], (data) => {
          return res
        })
        openSnackBar({ message: "Lab instance deleted" })
      },
      onError: (err) => {
        openErrorSnackbar(err, "There was an error deleting this lab")
      },
    })
    setRemoving(false)
  }

  return (
    <Box height="100%" width="100%" className={classes.container}>
      {/* List the info that should be displayed */}
      <Box className={classes.contentContainer} onClick={openEditDialog}>
        <Box width="10%" className={classes.title}>
          <Box display="flex">{instance.name}</Box>
        </Box>
        <Box width="15%" className={classes.server}>
          <Box display="flex" justifyContent="left">
            {instance.instance_type}
          </Box>
        </Box>
        <Box width="25%" className={classes.updated}>
          <Box display="flex">{instance.instance_username}</Box>
        </Box>
      </Box>
      <Box
        width="5%"
        display="flex"
        flexShrink="0"
        flexGrow="0"
        visibility={disabled ? "hidden" : "visible"}
      >
        <PermissionsWrapper permissionGroup="admin">
          <IconButton
            className={classes.removeButton}
            size="small"
            onClick={handleRemoveInstance}
            disabled={removing}
          >
            {removing && (
              <CircularProgress size={12} style={{ position: "absolute" }} />
            )}
            <RemoveCircleIcon style={{ fontSize: "inherit" }} />
          </IconButton>
        </PermissionsWrapper>
      </Box>
    </Box>
  )
}

export default InstanceCard

InstanceCard.propTypes = {
  instance: PropTypes.object,
  instanceTypes: PropTypes.array,
  lab: PropTypes.object,
  disabled: PropTypes.bool,
}
